export default __webpack_public_path__ + "media/broken-pipe.776a5a9f.svg";